var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMissed2 = function SvgMissed2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 1C14.187 1 18 4.813 18 9.5c0 4.687-3.813 8.5-8.5 8.5C4.813 18 1 14.187 1 9.5 1 4.813 4.813 1 9.5 1Zm0 1C5.364 2 2 5.364 2 9.5S5.364 17 9.5 17 17 13.636 17 9.5 13.636 2 9.5 2Zm.5 10v1H9v-1h1Zm0-6v5H9V6h1Z",
    fill: "#000"
  })));
};
export default SvgMissed2;